import { parseTierPrice } from '../price/tierPricing';
import { buildFscProductDisplayNames, getFscSkuDisplayName } from './fscCatalogHelpers';
import { getFscIncludedCredits, getFscSelectedCreditProduct } from './fscCreditPacksHelpers';
export const buildFscSkuQuantityCart = seats => seats.map(({
  productApiName,
  quantity
}) => ({
  productApiName,
  skuQuantity: quantity
}));
export const buildFscOrderSummaryDetails = ({
  catalog,
  tier,
  currencyCode,
  mode,
  seats,
  getSeatName,
  option,
  purchaseOption
}) => {
  var _parseTierPrice2;
  const labels = buildFscProductDisplayNames(option);
  const getAmount = productApiName => {
    var _parseTierPrice, _purchaseOption$produ;
    return (_parseTierPrice = parseTierPrice((_purchaseOption$produ = purchaseOption.productPrices) === null || _purchaseOption$produ === void 0 || (_purchaseOption$produ = _purchaseOption$produ[productApiName]) === null || _purchaseOption$produ === void 0 ? void 0 : _purchaseOption$produ.monthlyPrice)) !== null && _parseTierPrice !== void 0 ? _parseTierPrice : 0;
  };
  const seatItems = seats.map(({
    productApiName,
    quantity
  }) => ({
    type: 'seat',
    id: productApiName,
    productApiName,
    name: getSeatName(productApiName),
    label: labels.get(productApiName),
    quantity,
    amount: getAmount(productApiName)
  }));
  const creditItems = [];

  /*
   * Included credits are shown in the purchase flow only. In the manage flow the
   * portal already owns them, so they are omitted from the summary.
   */
  if (mode === 'purchase') {
    creditItems.push({
      type: 'includedCredits',
      id: 'included-credits',
      credits: getFscIncludedCredits(catalog, tier)
    });
  }
  const {
    creditPackOption
  } = option;
  if (creditPackOption && creditPackOption.creditPack > 0) {
    const packApiName = creditPackOption.productAndSkuQuantity.productApiName;
    creditItems.push({
      type: 'additionalCredits',
      id: `additional-credits-${packApiName}`,
      credits: creditPackOption.creditPack,
      packName: getFscSkuDisplayName(catalog, packApiName),
      label: labels.get(packApiName),
      amount: getAmount(packApiName)
    });
  }
  const paymentTerm = purchaseOption.paymentTerm === 'ANNUAL' ? 'ANNUAL' : 'MONTHLY';
  const commitmentTerm = purchaseOption.commitmentTerm === 'ANNUAL' ? 'ANNUAL' : 'MONTHLY';
  let billingTerm;
  if (paymentTerm === 'ANNUAL') {
    billingTerm = {
      type: 'annual'
    };
  } else {
    billingTerm = {
      type: 'monthlyForCommitment',
      months: commitmentTerm === 'ANNUAL' ? 12 : 1
    };
  }
  const requestedSeats = mode === 'manage' ? seats.map(({
    productApiName,
    quantity
  }) => ({
    productApiName,
    incrementalQuantity: quantity
  })) : buildFscSkuQuantityCart(seats);
  const creditProduct = getFscSelectedCreditProduct(option);
  return {
    content: {
      tier,
      currencyCode,
      total: (_parseTierPrice2 = parseTierPrice(purchaseOption.monthlyPrice)) !== null && _parseTierPrice2 !== void 0 ? _parseTierPrice2 : 0,
      billingTerm,
      mode,
      groups: {
        seats: seatItems,
        credits: creditItems
      }
    },
    requestedProducts: creditProduct ? [...requestedSeats, creditProduct] : requestedSeats,
    paymentTerm,
    commitmentTerm
  };
};